import { FaPlus } from "react-icons/fa";
import { Button } from "./Buttons";

const PageTitle = ({ title, actionLabel, onAction, subtitle }) => {
  return (
    <div className="mb-3 md:mb-6 md:flex flex-col md:gap-3 sm:flex-row sm:items-center sm:justify-between   md:text-start   hiden ">
      <div>
        <h1 className="text-lg md:text-2xl font-bold text-gray-800">{title}</h1>
        {subtitle && <p className="hidden md:inline mt-1 text-xs md:text-sm text-gray-500">{subtitle}</p>}
      </div>

      {actionLabel && onAction && (
        <Button
          onClick={onAction}
          type=""
          size="middle"
          className="w-full md:w-auto bg-gradient-to-r text-white p-2.5 from-primary to-primary_hover hover:bg-primary_hover hover:scale-105 hover:to-[#166575] border-0 shadow-lg hover:shadow-xl rounded-lg font-semibold transition-all"
        >
          <FaPlus className="mr-2 h-4 w-4" />
         <span className=""> {actionLabel}</span> 
        </Button>
      )}
    </div>
  );
};

export default PageTitle;
